import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class OrganizationUserEntity extends Entity {
    constructor() {
        super(...arguments);
        this.creationDTTM = new Date(0);
        this.email = null;
        this.firstName = null;
        this.isTrial = null;
        this.lastName = null;
        this.licensed = false;
        this.licenseExpirationDTTM = null;
        this.licenseMaximumDevices = null;
        this.licenseStartDTTM = null;
        this.licenseTypeId = null;
        this.licenseTypeName = null;
        this.organizationId = 0;
        this.organizationName = null;
        this.organizationRoleId = null;
        this.organizationRoleName = null;
        this.organizationUserId = 0;
        this.trialExtensionsUsed = null;
        this.updatedByUserId = null;
        this.updatedDTTM = null;
        this.userId = null;
        this.userStatusId = null;
        this.userStatusName = null;
    }
    pk() {
        return this.userId || btoa(JSON.stringify(this));
    }
}
OrganizationUserEntity.schema = {
    creationDTTM: ISODate,
    licenseExpirationDTTM: ISODate,
    licenseStartDTTM: ISODate,
    updatedDTTM: ISODate
};
OrganizationUserEntity.key = 'OrganizationUser';
export { OrganizationUserEntity };
